import { Container, Card } from 'react-bootstrap';
import pen from '../../images/pen.png';
import canSpam from '../../images/can-spam.png';
import servicing from '../../images/servicing.png';

export default function HomeListManagement() {
  return (
    <Container fluid className="w-100 features">
      <div className="container listManagement">
        <div>
          <h2>List Management</h2>
          <p>
            Our seasoned marketers evaluate your email list, honing in on your
            consumer base to peak interest and deliver relevant content
            resulting in increased return on investment and maximizing your
            revenue.
          </p>
          <p className="mb-5">
            We handle all the set up regarding hardware and software, and
            perform all list maintenance, data cleaning, and unsub tasks for
            you. Simply put, start posting your email data to Datagenetx and we
            will take care of all the work and send you a check every month.
            Maximize your revenue with us.
          </p>
        </div>
        <div className="listManagementPhoto">
          <Card style={{ width: '18rem' }}>
            <Card.Img variant="top" src={pen} alt="pen" />
            <Card.Body>
              <Card.Title style={{ fontSize: '17px' }}>Copy Writing</Card.Title>
              <Card.Text>
                Let our experts develop your email creatives and write ad copy
                for campaigns
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: '18rem' }}>
            <Card.Img variant="top" src={canSpam} alt="pen" />
            <Card.Body>
              <Card.Title style={{ fontSize: '17px' }}>
                CAN-SPAM Compliant
              </Card.Title>
              <Card.Text>
                We are 100% in compliance with the CAN-SPAM act.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: '18rem' }}>
            <Card.Img variant="top" src={servicing} alt="pen" />
            <Card.Body>
              <Card.Title style={{ fontSize: '17px' }}>
                Data Servicing
              </Card.Title>
              <Card.Text>
                We handle all the cleaning and bouncing of your data records for
                you.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
}
